<template>
  <div :class="isMax?'isMax':'isMoadl'">
    <div class="center-title">
      <span>{{title}}</span>
      <span v-if="!isMax">
        <svg @click.stop='minOperation' t="1675991873943" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11850" width="22" height="22"><path d="M829.160727 880.360727L584.145455 635.345455a36.212364 36.212364 0 1 1 51.2-51.2l245.015272 245.015272a36.212364 36.212364 0 1 1-51.2 51.2z" fill="#A2A5B4" p-id="11851"></path><path d="M790.109091 612.864h-206.848a36.212364 36.212364 0 0 1 0-72.424727h206.848a36.212364 36.212364 0 0 1 0 72.424727z" fill="#A2A5B4" p-id="11852"></path><path d="M615.936 787.083636v-206.894545a36.212364 36.212364 0 0 0-72.424727 0v206.894545a36.212364 36.212364 0 0 0 72.424727 0z" fill="#A2A5B4" p-id="11853"></path><path d="M182.132364 127.860364l245.015272 245.015272a36.212364 36.212364 0 1 1-51.2 51.2L130.932364 179.060364a36.212364 36.212364 0 1 1 51.2-51.2z" fill="#A2A5B4" p-id="11854"></path><path d="M221.184 395.357091h206.848a36.212364 36.212364 0 0 1 0 72.424727H221.184a36.212364 36.212364 0 0 1 0-72.424727z" fill="#A2A5B4" p-id="11855"></path><path d="M395.357091 221.184v206.848a36.212364 36.212364 0 0 0 72.424727 0V221.184a36.212364 36.212364 0 0 0-72.424727 0z" fill="#A2A5B4" p-id="11856"></path></svg>
        <svg @click.stop='maxOperation' t="1675991924873" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11993" width="22" height="22"><path d="M793.6 847.127273l-179.2-179.2a36.212364 36.212364 0 0 1 51.2-51.2l179.2 179.2a36.212364 36.212364 0 1 1-51.2 51.2z" fill="#A2A5B4" p-id="11994"></path><path d="M830.696727 655.825455v206.848a36.212364 36.212364 0 0 0 72.424728 0v-206.894546a36.212364 36.212364 0 0 0-72.424728 0z" fill="#A2A5B4" p-id="11995"></path><path d="M656.523636 829.998545h206.848a36.212364 36.212364 0 0 1 0 72.378182h-206.848a36.212364 36.212364 0 0 1 0-72.378182zM339.456 392.983273L193.163636 246.690909a36.212364 36.212364 0 1 1 51.2-51.2l146.292364 146.292364a36.212364 36.212364 0 0 1-51.2 51.2z" fill="#A2A5B4" p-id="11996"></path><path d="M370.874182 195.956364H164.026182a36.212364 36.212364 0 0 1 0-72.378182h206.848a36.212364 36.212364 0 0 1 0 72.378182z" fill="#A2A5B4" p-id="11997"></path><path d="M196.701091 370.176V163.281455a36.212364 36.212364 0 0 0-72.424727 0v206.894545a36.212364 36.212364 0 0 0 72.424727 0z" fill="#A2A5B4" p-id="11998"></path><path d="M847.872 233.053091l-179.2 179.2a36.212364 36.212364 0 0 1-51.2-51.2l179.2-179.2a36.212364 36.212364 0 1 1 51.2 51.2z" fill="#A2A5B4" p-id="11999"></path><path d="M656.523636 195.956364h206.848a36.212364 36.212364 0 0 0 0-72.378182h-206.848a36.212364 36.212364 0 0 0 0 72.378182z" fill="#A2A5B4" p-id="12000"></path><path d="M830.696727 370.176V163.281455a36.212364 36.212364 0 0 1 72.424728 0v206.894545a36.212364 36.212364 0 0 1-72.424728 0z" fill="#A2A5B4" p-id="12001"></path><path d="M393.681455 687.243636l-146.245819 146.245819a36.212364 36.212364 0 1 1-51.2-51.2l146.245819-146.245819a36.212364 36.212364 0 0 1 51.2 51.2z" fill="#A2A5B4" p-id="12002"></path><path d="M196.701091 655.825455v206.848a36.212364 36.212364 0 0 1-72.424727 0v-206.894546a36.212364 36.212364 0 0 1 72.424727 0z" fill="#A2A5B4" p-id="12003"></path><path d="M370.874182 829.998545H164.026182a36.212364 36.212364 0 0 0 0 72.378182h206.848a36.212364 36.212364 0 0 0 0-72.378182z" fill="#A2A5B4" p-id="12004"></path></svg>
        <svg @click.stop='closeMoadl' t="1675991965229" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12141" width="22" height="22"><path d="M230.385866 742.382499m25.606007-25.606007l460.776492-460.776492q25.606008-25.606008 51.212016 0l0 0q25.606008 25.606008 0 51.212016l-460.776492 460.776491q-25.606008 25.606008-51.212016 0l0 0q-25.606008-25.606008 0-51.212015Z" fill="#A2A5B4" p-id="12142"></path><path d="M716.801278 768.02142L255.991873 307.212016a36.212364 36.212364 0 0 1 51.212016-51.212016l460.776492 460.776492a36.212364 36.212364 0 0 1-51.212016 51.212015z" fill="#A2A5B4" p-id="12143"></path></svg>
      </span>
    </div>
    <div class="custormForm" v-if="!loadingEdit">
      <a-form :model="ruleForm" :colon= false :rules="rules" ref='modalFormRef' autocomplete="off">
        <!-- 基本信息 -->
        <div class="custorm-base" v-if="fieldSetList.customer_base.show">
          <div class="custorm-add-title">
            <svg t="1675991572773" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11572" width="22" height="22"><path d="M298.666667 128v64H234.666667a21.333333 21.333333 0 0 0-20.992 17.493333L213.333333 213.333333v640a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.666666a21.333333 21.333333 0 0 0 20.992-17.493334L810.666667 853.333333V213.333333a21.333333 21.333333 0 0 0-17.493334-20.992L789.333333 192H725.333333V128h64a85.333333 85.333333 0 0 1 85.333334 85.333333v640a85.333333 85.333333 0 0 1-85.333334 85.333334h-554.666666a85.333333 85.333333 0 0 1-85.333334-85.333334V213.333333a85.333333 85.333333 0 0 1 85.333334-85.333333H298.666667z m224 554.666667a32 32 0 1 1 0 64h-192a32 32 0 1 1 0-64h192z m170.666666-170.666667a32 32 0 1 1 0 64h-362.666666a32 32 0 1 1 0-64h362.666666z m0-170.666667a32 32 0 1 1 0 64h-362.666666a32 32 0 0 1 0-64h362.666666zM576 53.333333a85.333333 85.333333 0 0 1 85.333333 85.333334v42.666666a85.333333 85.333333 0 0 1-85.333333 85.333334h-128a85.333333 85.333333 0 0 1-85.333333-85.333334v-42.666666a85.333333 85.333333 0 0 1 85.333333-85.333334h128z m0 64h-128a21.333333 21.333333 0 0 0-20.992 17.493334L426.666667 138.666667v42.666666a21.333333 21.333333 0 0 0 17.493333 20.992l3.84 0.341334h128a21.333333 21.333333 0 0 0 20.992-17.493334L597.333333 181.333333v-42.666666a21.333333 21.333333 0 0 0-17.493333-20.992l-3.84-0.341334z" fill="#333333" p-id="11573"></path></svg>
            <h3>基本信息</h3>
          </div>
          <div class="custorm-content addContent">
            <a-form-item label="客户名称" name='name' :rules="fieldSetList.name.notNull?rules.name:[{ required: false }]" v-if="fieldSetList.name.show">
              <a-input v-model:value="ruleForm.name" placeholder="请输入客户名称"  />
            </a-form-item>
            <a-form-item label="所属行业" name='industryList' :rules="fieldSetList.industry.notNull?rules.industry:[{ required: false }]" v-if="fieldSetList.industry.show">
              <indust-type 
                :selecNum='3'
                :oldIndstry="ruleForm.industryIdAndNameList" 
                @searchIndustTypehandle="searchIndusthandle"
              ></indust-type>
            </a-form-item>
            <a-form-item label="公司性质" name='nature' :rules="fieldSetList.nature.notNull?rules.nature:[{ required: false }]" v-if="fieldSetList.nature.show">
              <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" v-model:value="ruleForm.nature" placeholder="请选择公司性质" :options="gsxzSelect" :field-names="{ label: 'dicValue', value: 'dicKey' }">
                <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
              </a-select>
            </a-form-item>
            <a-form-item label="公司规模" name='scale' :rules="fieldSetList.scale.notNull?rules.scale:[{ required: false }]" v-if="fieldSetList.scale.show">
              <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" v-model:value="ruleForm.scale" placeholder="请选择公司规模" :options="gsgmSelect" :field-names="{ label: 'dicValue', value: 'dicKey' }">
                <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
              </a-select>
            </a-form-item>
            <a-form-item label="所在城市" name='city' :rules="fieldSetList.city.notNull?rules.city:[{ required: false }]" v-if="fieldSetList.city.show">
              <city-list 
                :oldSelData="ruleForm.cityList" 
                @searchCityhandle="searchCityhandle" 
                :selectNum='3'
                ></city-list>
            </a-form-item>
            <a-form-item label="办公地址" name='address' :rules="fieldSetList.address.notNull?rules.address:[{ required: false }]" v-if="fieldSetList.address.show">
              <a-input v-model:value="ruleForm.address" placeholder="请填写办公地址" maxlength="100"/>
            </a-form-item>
            <a-form-item label="融资阶段" name='financingStage' :rules="fieldSetList.financingStage.notNull?rules.financingStage:[{ required: false }]" v-if="fieldSetList.financingStage.show">
              <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }"  v-model:value="ruleForm.financingStage" placeholder="请选择融资阶段" :options="rzjdSelect" :field-names="{ label: 'dicValue', value: 'dicKey' }">
                <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
              </a-select>
            </a-form-item>
            <a-form-item label="公司网址" name='website' :rules="fieldSetList.website.notNull?rules.website:[{ required: false }]" v-if="fieldSetList.website.show">
              <a-input autocomplete="new-password" v-model:value="ruleForm.website" placeholder="请填写公司网址" maxlength="100"/>
            </a-form-item>
          </div>
        </div>
        <!-- 公司介绍 -->
        <div class="custorm-base" v-if="fieldSetList.customer_introduction.show">
          <div class="custorm-add-title">
            <svg t="1675991476967" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11294" width="22" height="22"><path d="M579.498667 896H104.832V317.141333c0-52.821333 33.194667-101.546667 84.992-121.856l261.162667-103.594666c47.658667-18.261333 101.546667 4.053333 120.234666 50.773333 4.138667 10.154667 6.229333 22.357333 6.229334 34.56V896h2.048z m-412.458667-60.928h350.293333V174.933333c0-16.213333-14.506667-30.464-31.104-30.464-4.138667 0-8.277333 0-12.416 2.048l-263.253333 103.552c-24.874667 12.202667-43.52 36.565333-43.52 67.029334v517.930666z" fill="#333333" p-id="11295"></path><path d="M892.501333 896H552.533333v-60.928h277.76v-339.2c0-32.469333-22.826667-60.928-53.930666-69.034667l-232.106667-60.928 16.554667-58.88 232.106666 60.885334c58.069333 16.256 99.541333 67.029333 99.541334 128V896z" fill="#333333" p-id="11296"></path><path d="M923.562667 896H73.813333C57.173333 896 42.666667 881.792 42.666667 865.536c0-18.261333 14.506667-30.464 31.104-30.464h849.792c16.597333 0 31.104 14.208 31.104 30.464 0 16.213333-14.506667 30.464-31.104 30.464zM395.093333 386.218667h-103.68c-16.554667 0-31.061333-14.250667-31.061333-30.464 0-16.256 14.506667-30.464 31.104-30.464h103.637333c16.554667 0 31.061333 14.208 31.061334 30.464 0 16.213333-14.506667 30.464-31.061334 30.464z m0 154.325333h-103.68c-16.554667 0-31.061333-14.208-31.061333-30.464 0-16.213333 14.506667-30.464 31.104-30.464h103.637333c16.554667 0 31.061333 14.250667 31.061334 30.464 0 16.256-14.506667 30.464-31.061334 30.464z m0 154.368h-103.68c-16.554667 0-31.061333-14.208-31.061333-30.464 0-16.213333 14.506667-30.464 31.104-30.464h103.637333c16.554667 0 31.061333 14.208 31.061334 30.464 0 16.256-14.506667 30.464-31.061334 30.464z m344.064 0h-62.208c-16.554667 0-31.061333-14.208-31.061333-30.464 0-16.213333 14.506667-30.464 31.061333-30.464h62.208c16.554667 0 31.061333 14.208 31.061334 30.464 0 16.256-14.506667 30.464-31.061334 30.464z" fill="#333333" p-id="11297"></path></svg>
            <h3>公司介绍</h3>
          </div>
          <div class="custorm-content">
            <a-form-item label="公司简介" name='introduction' :rules="fieldSetList.introduction.notNull?rules.introduction:[{ required: false }]" v-if="fieldSetList.introduction.show">
              <a-textarea v-model:value="ruleForm.introduction"  placeholder="请输入公司简介" :auto-size="{ minRows: 3, maxRows: 5 }"  maxlength="2000"  />
            </a-form-item>
            <a-form-item label="公司福利" name='benefits' :rules="fieldSetList.benefits.notNull?rules.benefits:[{ required: false }]" v-if="fieldSetList.benefits.show">
              <a-textarea v-model:value="ruleForm.benefits"  placeholder="请输入公司福利" :auto-size="{ minRows: 3, maxRows: 5 }" maxlength="2000" />
            </a-form-item>
          </div>
        </div>
        <!-- 共享权限 -->
        <div class="custorm-base custorm-base-share">
          <div class="custorm-add-title">
            <svg t="1675991523716" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11434" width="22" height="22"><path d="M746.666667 117.333333a128 128 0 1 1-96.768 211.754667L396.629333 493.653333a149.077333 149.077333 0 0 1 8.405334 60.16l288.085333 140.501334a128 128 0 1 1-28.842667 57.173333l-277.461333-135.338667a149.333333 149.333333 0 1 1-24.234667-176.725333l258.730667-168.021333A128 128 0 0 1 746.666667 117.333333z m42.666666 597.333334a64 64 0 1 0 0 128 64 64 0 0 0 0-128z m-533.333333-256a85.333333 85.333333 0 1 0 0 170.666666 85.333333 85.333333 0 0 0 0-170.666666z m490.666667-277.333334a64 64 0 1 0 0 128 64 64 0 0 0 0-128z" fill="#333333" p-id="11435"></path></svg>
            <h3>共享权限</h3>
          </div>
          <div class="custorm-content">
            <a-form-item label="添加共享">
              <a-button class="share-btn" block @click="addShare" :disabled="ruleForm.shareInfoList.length == 5">
                <svg t="1675943721655" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10243" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22"><path d="M298.666667 480m32 0l362.666666 0q32 0 32 32l0 0q0 32-32 32l-362.666666 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#4f5b6e" p-id="10244"></path><path d="M480 725.333333m0-32l0-362.666666q0-32 32-32l0 0q32 0 32 32l0 362.666666q0 32-32 32l0 0q-32 0-32-32Z" fill="#4f5b6e" p-id="10245"></path></svg>
                添加共享
              </a-button>
            </a-form-item>
            <a-form-item name='shareInfoList' v-if="ruleForm.shareInfoList.length" label="共享权限">
              <div v-for="(item,index) in ruleForm.shareInfoList" :key='index' class="shareList-box">
                <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" v-model:value="item.shareScope" placeholder="请选择" :options="powerList" @select="value => handleChangeScope(value, index)">
                  <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                </a-select>
                <a-select 
                  :getPopupContainer=" triggerNode => {return triggerNode.parentNode }"
                  v-model:value="item.sharedList" 
                  placeholder="请选择顾问姓名" 
                  show-search
                  mode="multiple"
                  :filter-option="filterOption"
                  @focus="handleFocus(ruleForm.shareInfoList[index].shareScope)"
                  @change="value => handleChange(value, index)"
                  :disabled="!ruleForm.shareInfoList[index].shareScope"
                  dropdownClassName="sharedUserDropdown"
                  option-label-prop="label"
                  :not-found-content="fetching ? undefined : '无数据'"
                >
                  <template v-if="fetching" #notFoundContent>
                    <a-spin size="small" />
                  </template>
                  <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                  <a-select-option v-for="item1 in usrDropdownList" :key="item1.id" :value="item1.id" :label="item1.name"><img class="img-phone" :src="item1.headPhoto" />{{ item1.name }}<span class="icon-status" v-if="item1.accountStatus == 0">(已关闭)</span><span class="icon-status" v-if="item1.staffStatus == 0">(已离职)</span></a-select-option>
                </a-select>
                <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" v-model:value="item.permission" placeholder="请选择共享权限" :options="gxqxSelect" >
                  <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                </a-select>
                <svg @click="deleteShare(index)" t="1675991656456" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11710" width="14" height="14"><path d="M858.258286 255.488v653.238857c0 21.211429-17.188571 38.4-38.546286 38.4H202.971429a38.4 38.4 0 0 1-38.546286-38.4v-653.165714h693.833143m77.092571-76.873143H87.332571v768.438857c0 42.422857 34.596571 76.873143 77.092572 76.873143h693.833143c42.496 0 77.092571-34.450286 77.092571-76.8V178.614857z" fill="#A2A5B4" p-id="11711"></path><path d="M280.137143 176.786286V76.8h462.482286v99.913143H280.137143m-77.092572 76.8h539.648c42.569143 0 77.092571-34.377143 77.092572-76.8V76.8C819.712 34.377143 785.188571 0 742.619429 0H280.137143c-42.496 0-77.092571 34.450286-77.092572 76.8v176.786286z" fill="#A2A5B4" p-id="11712"></path><path d="M985.453714 178.029714H38.546286a38.4 38.4 0 1 0 0 76.8h946.907428a38.4 38.4 0 1 0 0-76.8z m-589.970285 231.131429c21.211429 0 38.546286 17.334857 38.546285 38.619428v307.2a38.546286 38.546286 0 0 1-77.092571 0v-307.2c0-21.284571 17.261714-38.546286 38.546286-38.546285z m231.277714 0c21.211429 0 38.546286 17.334857 38.546286 38.619428v307.2a38.546286 38.546286 0 0 1-77.092572 0v-307.2c0-21.284571 17.261714-38.546286 38.546286-38.546285z" fill="#A2A5B4" p-id="11713"></path></svg>
              </div>
            </a-form-item>
              
          </div>
        </div>
      </a-form>
    </div>
    <!-- 按钮 -->
    <div class="btn-item" >
      <a-button class="mainBtn" type="primary"  @click="handleOk" :loading='loading'>保存</a-button>
    </div>
  </div>
</template>
<script>
import {
  CaretDownOutlined,
} from "@ant-design/icons-vue";
import {useRouter} from 'vue-router'
import { message } from "ant-design-vue";
import { defineComponent, reactive, toRefs,onMounted,getCurrentInstance } from "vue";
import CityList from '@/components/search/city.vue'
import IndustType from '@/components/search/indust.vue'
import getAdd from "@/composables/add"
import { getDicList,getFieldSet } from "@/composables/base"
import {
  userSearchApi, //参与者-用户下拉框
} from '@/api/comm'
import {
  addCustomerAPI,//添加客户
  updateCustomerAPI,//更新客户
  customerDetailEditAPI,//获取客户详情
  checkCustomerNameAPI,//校验客户名称是否已存在
} from "@/api/customer"
export default defineComponent({
  props:['addPar'],
   components: {
    CaretDownOutlined,
    CityList,
    IndustType,
  },
  setup (props,){
    const valrClientName = async (_rule, value) => {
      if(value){
        let param={
          customerId:newData.id,
          customerName:value
        }
        await checkCustomerNameAPI(param).then(res=>{
          if(res.code == '200'){
            return Promise.resolve()
          }else{
            return Promise.reject(res.message);
          }
        })
      }else{
        return Promise.reject('请输入5-100字符的客户名称');
      }
    }
    const rules ={
      name:[
        {required: true, validator: valrClientName, trigger: 'blur'},
        {message: "请输入5-100字符的客户名称", trigger: 'blur',min: 5, max: 100,}
      ],
      industryList:[{required: true, message: "请选择行业类别", trigger: 'blur',}],
      city:[{required: true, message: "请选择城市", trigger: 'blur',}],
      nature:[{required: true, message: "请选择公司性质", trigger: 'change',}],
      scale:[{required: true, message: "请选择公司规模", trigger: 'change',}],
      financingStage:[{required: true, message: "请选择融资阶段", trigger: 'change',}],
      address:[{required: true, message: "请填写办公地址", trigger: 'blur',}],
      introduction:[{required: true, message: "请输入公司简介", trigger: 'blur',}],
      benefits:[{required: true, message: "请输入公司福利", trigger: 'blur',}],
      status:[{required: true, message: "请选择客户状态", trigger: 'change',}],
      website:[{required: true, message: "请填写公司网址", trigger: 'blur',}],
    }//校验规则
    var data = reactive({
      fetching:false,
      ruleForm:{
        name: "",
        industryList: [], //行业数据
        nature: undefined,
        scale: undefined,
        financingStage:undefined,
        introduction: "",
        benefits:'',
        address: "", //办公地址
        shareInfoList:[
          {shareScope:'COLLEAGUE',sharedList:[],permission:1}
        ],
        city:[],
      },//客户表单对象
      modalFormRef:{},//组件id 
      loading:false,
      loadingEdit:true,
      usrDropdownList:[],//顾问下拉框
      path:'addCustorm',
      id:'',
      title:'客户',
      addPar:props.addPar,
      gsxzSelect:[],
      gsgmSelect:[],
      rzjdSelect:[],
      fieldSetList:{
        name: {},
        industry: {}, //行业数据
        nature: {},
        scale: {},
        financingStage:{},
        introduction: {},
        benefits:{},
        address: {}, //办公地址
        city:{},
        website:{},
        customer_base:{},
        customer_introduction:{},
      },
      isSelect:[],
    })
    
    onMounted(async()=>{
      data.fieldSetList = await getFieldSet('CUSTOMER')//客户设置字段
      data.fieldSetList.nature.show?data.gsxzSelect = await getDicList('COMPANY_NATURE',data.fieldSetList.nature.notNull):''//公司性质
      data.fieldSetList.scale.show?data.gsgmSelect = await getDicList('CUSTOMER_SCALE',data.fieldSetList.scale.notNull):''//公司规模
      data.fieldSetList.financingStage.show?data.rzjdSelect = await getDicList ('CUSTOMER_FINANCING_STAGE',data.fieldSetList.financingStage.notNull):''//融资阶段
      if(newData.id && maxIndex == -1){//index == -1修改最大化走本地存储
        getDetail()
      }else{
        data.loadingEdit=false
      }
    })
     
    const {
      isMax,
      closeMoadl,
      maxOperation,
      minOperation,
      newData,
      maxIndex
    } = getAdd(data)
    // 添加共享
    const addShare=()=>{
      data.ruleForm.shareInfoList.push({shareScope:'COLLEAGUE',sharedList:[],permission:1})
    }
    //删除共享
    const deleteShare=(index)=>{
      data.ruleForm.shareInfoList.splice(index,1)
    }
    //保存
    const router=useRouter()
    const $bus = getCurrentInstance().appContext.config.globalProperties.$bus
    const handleOk = () => {
      data.modalFormRef.validateFields().then((res)=>{
        data.loading = true
        if(newData.id){
          var url = updateCustomerAPI
          res.id = newData.id
        }else{
          url = addCustomerAPI
        }
        if(res.shareInfoList && res.shareInfoList.length){
          res.shareInfoList.forEach((item,index)=>{
            if(item.sharedList.length ==0){
              res.shareInfoList.splice(index,1)
            }
          })
        }
        url(res).then(res=>{
          data.loading = false
          if(res.success){
            message.success('保存成功');
            closeMoadl()
            if(!isMax){
              $bus.emit('updateCustormList')
              $bus.emit('updateLeft')
            }else{
              let path = 'customers'
              router.push(path)
            }
          }else{
            message.warning(res.message);
          }
        })
      }).catch((rep)=>{
        message.warning('请补全基本信息')
        data.modalFormRef.scrollToField(rep.errorFields[0].name)//滚动到对应字段位置
      })

    }
    //获取城市选择的值
    const searchCityhandle = (arr) => {
      data.ruleForm.city = []
      data.ruleForm.cityList = arr
      if(arr.length){
        arr.forEach(item=>{
          data.ruleForm.city.push(item.value)
        })
      }  
    }
    //行业数据发生改变-传值
    const searchIndusthandle = (val) => {
      data.ruleForm.industryList = [];
      data.ruleForm.industryIdAndNameList = val
      if (val.length > 0) {
        val.forEach(item => {
          data.ruleForm.industryList.push(item.value);
        })
      }
    }
    //获取客户详情
    const getDetail =()=>{
      let param =  {
        id:newData.id
      }
      customerDetailEditAPI(param).then(res=>{
        data.loadingEdit = false;
        if(res.success){
          data.ruleForm = res.data
          let cityList = []
          if(data.ruleForm.cityList.length){
            data.ruleForm.city=[]
            data.ruleForm.cityList.forEach(item=>{
              data.ruleForm.city.push(item.id)
              let cityObj = {
                label: item.areaName,
                value: item.id
              }
              cityList.push(cityObj)
            })
          }
          data.ruleForm.cityList = cityList
          let arr =[]
          data.ruleForm.industryList = []
          if(data.ruleForm.industryIdAndNameList.length){
            data.ruleForm.industryIdAndNameList.forEach(item=>{
              data.ruleForm.industryList.push(item.id)
              let industryObj = {
                value:item.id,
                label:item.name,
              }
              arr.push(industryObj)
            })
          }
          data.ruleForm.industryIdAndNameList = arr
          if(data.ruleForm.shareInfoList.length){
            getParticipantName(2)
            data.ruleForm.shareInfoList.forEach(item =>{
              var arr = []
              item.sharedList.forEach(item1 =>{
                arr.push(item1.id)
              })
              item.sharedList = arr
              // getParticipantName(2)
            })
          }
        }
      })
    }
    //参与者-查询用户
    const getParticipantName = (staffType) => {
      data.fetching = true
      let param = {
        searchCondition: '',
        staffType: staffType,
        customerId:newData.id,
      }
      userSearchApi('customer',param).then(res => {
        data.fetching = false
        if (res.success) {
          res.data.forEach(item=>{
            item.key =item.id
          })
          data.usrDropdownList = res.data;
        } else {
          message.warning(res.message);
        }
      })
    }
    //参与者-用户下拉框搜索
    const  handleFocus=(id)=>{
      id=='ALL'?id=2:id=1
      data.usrDropdownList = []
      getParticipantName(id)
    }
    //共享人值改变
    const handleChange=(value, index)=>{
      data.ruleForm.shareInfoList[index].sharedList = value
    }
    //同事/所有人下拉框改变
    const handleChangeScope=(value, index)=>{
      data.ruleForm.shareInfoList[index].sharedList = []
      data.usrDropdownList = []
    }
    return{
      ...toRefs(data),
      powerList:[
        {
          value: "COLLEAGUE",
          label: "同事",
        },
        {
          value: "ALL",
          label: "所有人",
        },
      ],
      gxqxSelect:[
        {
          value: 1,
          label: "可以查看",
        },
        {
          value: 2,
          label: "可以编辑",
        },
        {
          value: 3,
          label: "可以发布/编辑职位",
        },
      ],//共享权限
      rules,//校验规则
      addShare,//添加共享方法
      deleteShare,//删除共享方法
      handleOk,

      isMax,
      closeMoadl,
      maxOperation,
      minOperation,
      newData,
      searchCityhandle,
      searchIndusthandle,
      getDetail,
      getParticipantName,
      handleFocus,
      handleChange,
      handleChangeScope,
    }
  }
});
</script>
<style scoped src="@/assets/css/add.css" >
</style>
<style scoped>
/* 共享权限样式 */
.shareList-box{
  display: flex;
  align-items: center;
}
.shareList-box:not(:last-of-type){
  margin-bottom: 16px;
}
.shareList-box .ant-select:not(:nth-of-type(2)){
  width: 20%!important;
}
.shareList-box .ant-select:nth-of-type(2){
  flex: 1;
}
.shareList-box .ant-select{
  margin-right: 8px;
}
::v-deep .ant-select-multiple .ant-select-selection-item{
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #DCDFE6;
  padding-inline-end:8px;

}
::v-deep .ant-select-multiple .ant-select-selection-item-content{
  margin-right: 10px;
}
::v-deep .ant-select-multiple .ant-select-selection-item-remove > .anticon{
  vertical-align:0;
}
.share-btn{
  display: flex;
  align-items: center;
  justify-content: center;
}
.share-btn,.share-btn:focus{
  /* width: 88px;
  height: 32px; */
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  color: #333;
}
.share-btn:hover,.share-btn:active {
  border: 1px solid #507AFD;
  color: #507AFD;
}
.share-btn:hover svg path,.share-btn:active svg path,
.shareList-box:hover svg path,.shareList-box:active svg path,
.ant-modal-close-x:hover svg path,.ant-modal-close-x:active svg path{
  fill: #507AFD;
}
.shareList-box:hover,.shareList-box:active{
  cursor: pointer;
}
::v-deep .shareList-box img,
::v-deep .shareList-box .ant-select-item-option-content img{
  width: 18px;
  height: 18px;
  border-radius: 50%; 
  margin-right: 8px; 
}
::v-deep .shareList-box .ant-tag{
  border-radius: 12px;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  color: #333333;
}
</style>
<style>
.sharedUserDropdown.ant-select-dropdown-empty{
  display: flex;
  justify-content: center;
}
</style>
